import { render, staticRenderFns } from "./area-chart.vue?vue&type=template&id=40b8184a&scoped=true"
import script from "./area-chart.vue?vue&type=script&lang=js"
export * from "./area-chart.vue?vue&type=script&lang=js"
import style0 from "./area-chart.vue?vue&type=style&index=0&id=40b8184a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b8184a",
  null
  
)

export default component.exports